import React from 'react';
import MultiSearchSelect from '../../../components/Forms/Input/MultiSearchSelect';

interface BranchOption {
  id: number;
  name: string;
}

interface Props {
  form: { branchIds: number[] };
  options: BranchOption[];
  onChange: (field: string, value: any) => void;
  errors: Record<string, string>;
}

const UserBranchSelector: React.FC<Props> = ({ form, options, onChange, errors }) => {
  return (
    <MultiSearchSelect
      label="Sucursales"
      name="branchIds"
      iconKey="branch"
      selectedValues={form.branchIds}
      onChange={(values) => onChange('branchIds', values)}
      options={options}
      searchPlaceholder="Buscar sucursal..."
      required
      error={errors.branchIds}
    />
  );
};

export default UserBranchSelector;
